<script setup>
import {
  StealieButton,
  StealieHeading,
  StealieOverline,
  StealieTextInput,
  StealieParagraph,
  StealieLink,
} from "@get-overalls/fe-stealie";
import { useRoute } from "vue-router";
import SignInLayout from "@/layouts/SignInLayout.vue";
import { useSignUp } from "./composables/useSignUp";
import FormError from "@/components/FormError.vue";

const { formData, errors, submitError, isSubmitting, handleSignUpSubmit } = useSignUp();
const route = useRoute();
formData.value.companySlug = route.params.companySlug;
</script>

<template>
  <SignInLayout>
    <div data-sr-unmask>
      <div>
        <StealieOverline>Sign Up</StealieOverline>
      </div>
      <div class="col-span-4">
        <StealieHeading size="lg" class="mb-6 text-balance"> Welcome! </StealieHeading>
      </div>
      <div>
        <form
          aria-label="Sign up form"
          method="post"
          novalidate
          class="flex flex-col gap-6"
          @submit.prevent="handleSignUpSubmit"
        >
          <div>
            <StealieTextInput
              v-model="formData.name"
              name="name"
              type="text"
              label="First Name"
              required
              :error-message="errors.name"
            />
          </div>
          <div>
            <StealieTextInput
              v-model="formData.lastName"
              name="lastName"
              type="text"
              label="Last Name"
              required
              :error-message="errors.lastName"
            />
          </div>
          <div>
            <StealieTextInput
              v-model="formData.email"
              name="email"
              type="email"
              label="Work Email"
              autocomplete="username"
              required
              :error-message="errors.email"
            />
          </div>
          <div>
            <StealieTextInput
              v-model="formData.password"
              name="password"
              type="password"
              label="Password"
              autocomplete="current-password"
              required
              :error-message="errors.password"
            />
          </div>
          <FormError v-if="submitError" :error="submitError" />
          <div>
            <StealieButton
              type="submit"
              class="mt-2 mb-6"
              full-width
              :loading="isSubmitting"
            >
              Sign up
            </StealieButton>
          </div>
        </form>
        <div>
          <StealieParagraph size="sm" class="mb-4">
            By signing up, you acknowledge that you have read, understood, and agree to
            <StealieLink
              to="https://getoveralls.com/terms-of-use?hsLang=en"
              external-link
              underline
              >Overalls Terms</StealieLink
            >
            and
            <StealieLink
              to="https://getoveralls.com/privacy-policy?hsLang=en"
              external-link
              underline
              >Privacy Policy</StealieLink
            >.
          </StealieParagraph>
          <StealieParagraph size="sm" class="mb-4">
            Already a member?
            <StealieLink :to="{ name: 'SignIn' }" underline>Sign in</StealieLink>
          </StealieParagraph>
        </div>
      </div>
    </div>
  </SignInLayout>
</template>
